module.exports = __webpack_public_path__ + "static/icon-12.b17c4f7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/diesal-generator/icon-12.jpg
// module id = 45
// module chunks = 168707334958949